(function(app) {
    app.constant("prefixes",
    [
        { ShortName: "Mr", LongName: "Mr." },
        { ShortName: "Mrs", LongName: "Mrs." },
        { ShortName: "Ms", LongName: "Ms." },
        { ShortName: "Miss", LongName: "Miss" },
        { ShortName: "Dr", LongName: "Dr." },
        { ShortName: "MrAndMrs", LongName: "Mr. and Mrs." }

    ]);
})(window.app); //jshint ignore:line